module.exports = __webpack_public_path__ + "img/pen-success-dark.27969ff.svg";